import { withStyles } from '@mui/styles';

import PageLoading from './pageLoading';
import muiStyles from './styles';

export default withStyles(muiStyles)(PageLoading);